/**
 * types
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */
export const REFRESH_USER_SHOP_INFO = 'REFRESH_USER_SHOP_INFO' // 刷新用户积分商城信息
export const REFRESH_USER_PHONE_INFO = 'REFRESH_USER_PHONE_INFO' // 用户手机信息
export const REFRESH_USER_PLATFORM = 'REFRESH_USER_PLATFORM' // 用户平台
export const REFRESH_USER_ID = 'REFRESH_USER_ID' // 用户的sessionid
export const REFRESH_USER_INFO = 'REFRESH_USER_INFO' // 用户的个人信息
export const REFRESH_USER_OPEN_ID = 'REFRESH_USER_OPEN_ID' // 用户的openid
export const REFRESH_ENTRANCE_APPNAME = 'REFRESH_ENTRANCE_APPNAME' // 字节跳动小程序端是那个入口进去